import { GridColDef, GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid-pro'
import React from 'react'
import tw from 'twin.macro'
import { CandidateActionButton } from 'src/components/candidate-pool/CandidateActionButton'
import { Chip } from 'src/components/shared/Chip'
import { OpportunityCandidateStatus } from 'src/constants/opportunity/enums'
import { vehicleNamesMap } from 'src/constants/vehicle'
import { OpportunityCandidate } from 'src/interfaces/opportunity'
import { colors } from 'src/theme'
import { gridFormatters } from 'src/utils/grid'

const candidateBaseColumns: GridColDef<OpportunityCandidate>[] = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1.2,
    minWidth: 160,
    valueGetter: (params: GridValueGetterParams<OpportunityCandidate>) =>
      `${params.row.firstName} ${params.row.lastName}`,
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 1.4,
    minWidth: 200,
    sortable: false,
  },
  {
    field: 'phone',
    headerName: 'Phone',
    flex: 1,
    minWidth: 140,
    sortable: false,
  },
  {
    field: 'vehicleType',
    headerName: 'Vehicle type',
    flex: 1,
    minWidth: 130,
    valueGetter: (params: GridValueGetterParams<OpportunityCandidate>) =>
      vehicleNamesMap[params.row.vehicleType] || params.row.vehicleType,
  },
  {
    field: 'marketTitle',
    headerName: 'Market',
    flex: 1,
    minWidth: 140,
    sortable: false,
  },
  {
    field: 'opportunityTitle',
    headerName: 'Opportunity',
    flex: 1.3,
    minWidth: 170,
    sortable: false,
  },
  {
    field: 'createdAt',
    headerName: 'Applied',
    flex: 1,
    minWidth: 140,
    valueFormatter: gridFormatters.formatSimpleDate,
  },
]

const contractorColumn: GridColDef<OpportunityCandidate> = {
  field: 'partnerDriverId',
  headerName: 'Contractor',
  flex: 1,
  minWidth: 140,
  sortable: false,
  renderCell: (params: GridRenderCellParams<OpportunityCandidate>) =>
    params.row.partnerDriverId ? (
      <Chip className={tw`bg-[#E6F9E9]`} textColor={colors.COLORS_GREEN_500} text="In onboarding" />
    ) : (
      <span>-</span>
    ),
}

const actionsColumn: GridColDef<OpportunityCandidate> = {
  field: 'actions',
  headerName: '',
  width: 68,
  sortable: false,
  align: 'right',
  renderCell: (params: GridRenderCellParams<OpportunityCandidate>) => (
    <CandidateActionButton candidate={params.row} />
  ),
}

/**
 * The Offered tab swaps the row kebab for a contractor chip: the candidate is already in onboarding, so there is
 * nothing left to act on from here.
 */
export const getCandidatePoolColumns = (
  selectedTab: OpportunityCandidateStatus,
): GridColDef<OpportunityCandidate>[] => {
  if (selectedTab === OpportunityCandidateStatus.Offered) {
    return [...candidateBaseColumns, contractorColumn]
  }

  return [...candidateBaseColumns, actionsColumn]
}
